import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, Pipe, signal, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { LoginRequest } from '../../../shared/models/generated';
import { AppAutofocusDirective } from '../../../shared/directives/appAutofocus.directive';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { StorageNames } from '../../../shared/constants/storage';
import { ModalService } from '../../../shared/services/modal.service';
import { PasswordChangeDialog } from '../../main/components/password-change-dialog/password-change-dialog';
import { ForgotPasswordDialog } from '../../main/components/forgot-password-dialog/forgot-password-dialog';
import { firstValueFrom } from 'rxjs';
import { isNotFound, isUnauthorized } from '../../../shared/helpers/error-helpers';
import { ProcessingDirective } from "../../../shared/directives/processing.directive";

@Component({
  selector: 'app-login',
  imports: [FormsModule, AppAutofocusDirective, ProcessingDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements AfterViewInit {
  @ViewChild('loginForm') form?: NgForm;
  @ViewChild('logoImage') logoImage?: ElementRef<HTMLImageElement>;
  request = {} as LoginRequest;

  constructor(private auth: AuthService, private router: Router) {

  }
  readonly submitting = signal(false);
  readonly submittingRegistration = signal(false);
  readonly logoUrl = signal<string>(`${environment.apiUrl}/api/tenants/current/logo/${window.location.host.split('.')[0]}`);
  readonly showPassword = signal(false);
  readonly isLogoLoaded = signal(false);

  message = signal('');

  ngAfterViewInit() {
    if (this.logoImage?.nativeElement.complete) {
      this.onLogoImageLoad();
    }

  }

  onLogoImageLoad() {
    if (this.isLogoLoaded()) {
      return;
    }

    this.isLogoLoaded.set(true);
  }

  async loginBiometrics() {
    try {
      await this.auth.loginBiometrics();
    } catch (err: any) {
      if (isUnauthorized(err)) {
        this.message.set("Usuario no autorizado");
      }
      else {
        console.error(err);
        this.message.set("Error inesperado, por favor intente nuevamente");
      }
    }
  }

  biometricsEnabled() {
    return window.PublicKeyCredential;
  }

  async loginAndRegister() {
    await this.login(true);
  }
  async login(registerBiometrics: boolean = false) {
    // if (this.form?.invalid) {
    //   this.message.set('Por favor verifique los datos ingresados');
    //   return;
    // }
    let submittinSignal = this.submitting;
    if (registerBiometrics) {
      submittinSignal = this.submittingRegistration;
    }
    try {
      submittinSignal.set(true);
      await this.auth.login(this.request, registerBiometrics);
    } catch (err: any) {
      if (err.status === 400) {
        var message = err.error?.detail;
        if (message == "MustChangePassword") {
          await this.changePassword();
          return;
        }
      }
      if (err.status === 401) {
        this.message.set(err.error ?? "Usuario o contraseña invalidos");
        return;
      } if (err.status === 403) {
        this.message.set("Usuario sin acceso");
        return;
      }
      console.error(err);
      this.message.set("Error inesperado, por favor intente nuevamente");

    }
    finally {
      submittinSignal.set(false);
    }
  }
  readonly modals = inject(ModalService);
  async changePassword() {
    const dialog = this.modals.open(PasswordChangeDialog, {}, state => {
      state.showCurrentPassword.set(false);
      state.currentPassword.set(this.request.password);
      state.passwordChangedCallback = async (x) => {
        await this.auth.changePassword(this.request.username, x.currentPassword, x.password);
        this.request.password = x.password;
        await this.login()
      }
    });
    if (await dialog.result) {
      this.login();
    }
  }
  async forgotPassword() {
    try {
      const dialog = this.modals.open(ForgotPasswordDialog, {}, state => {
        state.username.set(this.request.username);
      });
      const result = await dialog.result;
      if (result) {
        var component: ForgotPasswordDialog = dialog.componentInstance;

        this.modals.open(PasswordChangeDialog, {}, state => {
          state.showCurrentPassword.set(false);
          state.passwordChangedCallback = async (x) => {
            await firstValueFrom(this.auth.changePasswordWithToken(component.username(), component.token(), x.password));
            this.request.username = component.username();
            this.request.password = x.password;
            await this.login()
          };
        });
      }
    } catch (err: any) {
      console.error(err);
      this.message.set("Error inesperado, por favor intente nuevamente");
    }
  }
}
